var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.mg,"prefix":"M21","placeholder":"50X","rules":[_vm.validateClass]},on:{"input":function (event) { return _vm.validateClass(event) === true ? _vm.$emit('input', event) : null; }}})}
var staticRenderFns = []

export { render, staticRenderFns }